import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Image from 'next/image';

const HOMiiImage = (props) => {
    const {
        src,
        className,
        greyScale,
        animate,
        isContainerButton,
        isOldImage,
        containerWidth,
        containerHeight,
        alt,
        width,
        height,
        layout,
        objectFit,
        ...rest
    } = props;

    const [isClient, setIsClient] = useState(false);

    const [isError, setIsError] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    if (!isClient) {        
        return null;
    }

    const handlerImageError = () => {
        setIsError(true);
    }

    const renderImage = () => {      

        if (!isOldImage) {
            return (
                <StyledNextImg
                    {...rest}
                    width={width}
                    height={height}
                    layout={layout}
                    objectFit={objectFit}
                    src={src}
                    alt={alt}
                    className={isError ? 'no-image' : className}
                    $greyscale={greyScale}
                    $animate={animate}
                    onError={handlerImageError}
                />
            );
        }
        return (
            <StyledImg
                {...rest}
                width={width}
                height={height}
                src={src}
                alt={alt}
                className={isError ? 'no-image' : className}
                $greyscale={greyScale}
                $animate={animate}
                onError={handlerImageError}
            />
        );
    };

    if (animate) {
        if (isContainerButton) {
            return (
                <ImageHoverButton
                    containerWidth={containerWidth}
                    containerHeight={containerHeight}
                    aria-label={alt}
                >
                    {renderImage()}
                </ImageHoverButton>
            );
        }
        return <ImageHover>{renderImage()}</ImageHover>;
    }

    return <>{renderImage()}</>;
};

export default HOMiiImage;

HOMiiImage.propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string.isRequired,
    className: PropTypes.string,
    greyScale: PropTypes.bool,
    animate: PropTypes.bool,
    isContainerButton: PropTypes.bool,
    containerWidth: PropTypes.string,
    containerHeight: PropTypes.string,
    isOldImage: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    layout: PropTypes.string,
    objectFit: PropTypes.string,
};

const StyledImg = styled('img')(({ $greyscale, $animate }) => ({
    filter: $greyscale ? 'grayscale(95%)' : 'grayscale(0%)',
    margin: $animate ? '0 auto' : 'unset',
    transition: $animate ? 'transform 2s cubic-bezier(.16,1.08,.38,.98)' : undefined,
    '&:hover': {
        transform: $animate ? 'scale(1.1)' : 'none',
    },
}));

const StyledNextImg = styled(Image)(({ $greyscale, $animate }) => ({
    filter: $greyscale ? 'grayscale(95%)' : 'grayscale(0%)',
    margin: $animate ? '0 auto' : 'unset',
    transition: $animate ? 'transform 2s cubic-bezier(.16,1.08,.38,.98)' : undefined,
    '&:hover': {
        transform: $animate ? 'scale(1.1)' : 'none',
    },
}));

const ImageHover = styled('div')({
    borderRadius: 5,
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap',
});

const ImageHoverButton = styled('div')(({ containerWidth, containerHeight, opacity }) => ({
    width: containerWidth,
    height: containerHeight,
    opacity: opacity,
    background: 'none',
    border: 'none',
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexWrap: 'wrap',
    borderRadius: 5,
    '&:focus': {
        outline: 0,
    },
    '&:hover': {
        cursor: 'pointer',
    },
}));
